import { FaPlusCircle } from "react-icons/fa";
import { FcPicture } from "react-icons/fc";
import { useState, useEffect } from "react";
import Select, { StylesConfig } from "react-select";
import toast from "react-hot-toast";
import Creatable from "react-select/creatable";
import { createPortal } from "react-dom";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import logoGM from "assets/images/sitelogo.svg";
import sendRequest from "hooks/useAxios";
import toastFunction from "utils/toast";
export default function EditStoreModal({
  selectedItem,
  setForceUpdate,
  setShowEditStoreModal,
  showEditStoreModal,
}) {
  // useState
  const [show, setShow] = useState(false);
  const handleClose = () => setShowEditStoreModal(true);
  const [inputValue, setInptValue] = useState({
    logo: "",
    cover: "",
    title: "",
    address: "",
    tell: "",
    mobile: "",
    desc: "",
    whatsApp: "",
    insta: "",
    city: "",
    province: "",
    user: "",
    type: "",
    // fname:"",
    // lname:"",
    // user_mobile:"",
  });

  const [inputValueValid, setInptValueValid] = useState({
    logo: true,
    cover: true,
    title: true,
    address: true,
    tell: true,
    mobile: true,
    desc: true,
    whatsApp: true,
    insta: true,
    city: true,
    province: true,
    user: true,
    type: true,
    // fname:true,
    // lname:true,
    // user_mobile:true,
  });
  const [city, setCity] = useState([]);
  const [province, setProvince] = useState([
    { value: " 0", label: "گلستان" },
    { value: "1", label: "تهران" },
  ]);
  const [type, setType] = useState([
    { value: "0", label: "تامین کننده اصلی" },
    { value: "1", label: "تامین کننده عادی" },
  ]);
  const [user, setUser] = useState([]);
  const [displayStatus, setDisplayStatus] = useState("d-none");
  const [newUser, setNewUser] = useState({ fName: "", lName: "", mobile: "" });
  const [newUserValid, setNewUserValid] = useState({
    fName: true,
    lName: true,
    mobile: true,
  });
  // functions
  const ValidationNewUser = () => {
    let temp = true;
    if (newUser.fName) {
      setNewUserValid((prev) => {
        return { ...prev, fName: true };
      });
    } else {
      temp = false;
      setNewUserValid((prev) => {
        console.log("f", temp);

        return { ...prev, fName: false };
      });
    }
    if (newUser.lName) {
      setNewUserValid((prev) => {
        return { ...prev, lName: true };
      });
    } else {
      temp = false;
      setNewUserValid((prev) => {
        console.log("lf", temp);

        return { ...prev, lName: false };
      });
    }
    if (newUser.mobile) {
      setNewUserValid((prev) => {
        return { ...prev, mobile: true };
      });
    } else {
      temp = false;
      setNewUserValid((prev) => {
        console.log("m", temp);

        return { ...prev, mobile: false };
      });
    }
    return temp;
  };
  const changeHandler = (value, type) => {
    setInptValue((prev) => {
      return { ...prev, [type]: value.value };
    });
  };
  const phoneNumberValidation = (mobile) => {
    return /^09\d{9}$/.test(mobile);
  };
  const tellPattern = /^0\d{10}$/;

  const Validation = () => {
    let temp = true;
    if (phoneNumberValidation(inputValue.mobile)) {
      setInptValueValid((prev) => {
        return { ...prev, mobile: true };
      });
    } else {
      temp = false;
      setInptValueValid((prev) => {
        console.log("mobile", temp);
        return { ...prev, mobile: false };
      });
    }

    if (inputValue.title) {
      setInptValueValid((prev) => {
        return { ...prev, title: true };
      });
    } else {
      temp = false;
      setInptValueValid((prev) => {
        console.log("titl", temp);

        return { ...prev, title: false };
      });
    }
    if (inputValue.city) {
      setInptValueValid((prev) => {
        return { ...prev, city: true };
      });
    } else {
      temp = false;
      setInptValueValid((prev) => {
        console.log("city", temp);

        return { ...prev, city: false };
      });
    }
    if (inputValue.user) {
      setInptValueValid((prev) => {
        return { ...prev, user: true };
      });
    } else {
      temp = false;
      setInptValueValid((prev) => {
        console.log("usr", temp);

        return { ...prev, user: false };
      });
    }

    if (tellPattern.test(inputValue.tell)) {
      setInptValueValid((prev) => {
        return { ...prev, tell: true };
      });
    } else if (inputValue.tell != "" && !tellPattern.test(inputValue.tell)) {
      temp = false;

      setInptValueValid((prev) => {
        return { ...prev, tell: false };
      });
    }
    if (inputValue.type) {
      setInptValueValid((prev) => {
        return { ...prev, type: true };
      });
    } else {
      temp = false;
      setInptValueValid((prev) => {
        console.log("typ", temp);

        return { ...prev, type: false };
      });
    }
    return temp;
  };
  const toastCustome = (message) => {
    return toast.custom(
      <div
        className="d-flex  "
        style={{
          backgroundColor: "white",
          borderRadius: "10px",
          boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
          padding: "10px",
        }}
      >
        <div>
          <img style={{ width: "40px" }} src={logoGM}></img>
        </div>
        <div style={{ alignSelf: "center", marginRight: "5px" }}>{message}</div>
      </div>
    );
  };
  const selectType = (type) => {
    switch (type) {
      case "0":
        return "0";
      case "1":
        return "1";
        defult: return null;
    }
  };
  const sendEditStoreModal = () => {
    let fd = new FormData();
    console.log("inputValue.type", inputValue.type);
    fd.append(
      "updateValue",
      `title,${inputValue.title}@@address,${inputValue.address}
      @@cityId,${inputValue.city}@@description,${inputValue.desc}@@instagram,${
        inputValue.insta
      }@@whatsapp,${inputValue.whatsApp}@@type,${selectType(inputValue.type)}
      @@mobile,${inputValue.mobile}@@tell,${inputValue.tell} ${
        inputValue.user.value == "create"
          ? `@@fname,${newUser.fName} @@laname,${newUser.lName}@@user_mobile,${newUser.mobile}`
          : `@@admin_id,${inputValue.user}`
      } `
    );

    fd.append("logoFile", inputValue.logo);
    fd.append("coverFile", inputValue.cover);
    fd.append("businessesId", inputValue.businessesId);
    sendRequest("edit_shop_info", fd).then(({ data }) => {
      if (data.status == 1) {
        toastFunction("success", "ویرایش با موفقیت انجام شد.");

        setShowEditStoreModal(false);
        setForceUpdate((prev) => !prev);
      } else {
        toastFunction("error", "مشکلی در ویرایش فروشگاه پیش امده است");

        // toast.error("مشکلی در ویرایش فروشگاه پیش آمده است.");
      }
      console.log("data", data);
    });
  };
  // usEffects and api
  useEffect(() => {
    setInptValue({
      ...selectedItem,
      logo: selectedItem.url,
      cover: selectedItem.cover_file_id,
      title: selectedItem.title,
      address: selectedItem.address,
      tell: selectedItem.tell,
      mobile: selectedItem.mobile,
      whatsApp: selectedItem.whatsapp,
      desc: selectedItem.description,
      insta: selectedItem.instagram,
      city: selectedItem.cityId,
      user: selectedItem.admin_id,
      type: selectedItem.type,
      businessesId: selectedItem.id,
    });
  }, [selectedItem]);
  useEffect(() => {
    sendRequest("get_admin_users").then(({ data }) => {
      console.log("adminuser", data);
      setUser([
        { value: "create", label: "کاربر جدید" },
        ...data.users.map((value) => {
          return {
            value: value.id,
            label: value.fname + " " + value.lname + " " + value.mobile,
            // mobile: value.mobile,

            // phoneNumber: value.mobile,
          };
          // ...data,
        }),
      ]);
    }, []);
    sendRequest("Find_cities").then(({ data }) => {
      setCity([
        ...data.map((value) => {
          return {
            value: value.id,
            label: value.title,
            // phoneNumber: value.mobile,
          };
          // ...data,
        }),
      ]);
    });
  }, []);
  console.log("00", inputValue.city);
  const modalVar1 = (
    <Modal
      className="StoreModal"
      show={showEditStoreModal}
      onHide={() => {
        setShowEditStoreModal(false);
      }}
      size="lg"
    >
      <Modal.Header
        closeButton
        onClick={() => {
          setForceUpdate((prev) => !prev);
        }}
      >
        <h5 dir="ltr" className="modal-title" id="exampleModalLabel3">
          ویرایش فروشگاه
        </h5>
      </Modal.Header>
      <Modal.Body>
        {" "}
        <div
          className="style-container"
          style={{ background: "#f2e2c8", margin: "-16px" }}
        >
          <div className="edit-user-container" style={{ padding: "10px" }}>
            <form id="edit-user-form-data" className=" edit-container">
              <div>
                <div className="d-flex justify-content-center flex-wrap">
                  <div className="">
                    <div className="lable-modal">
                      <label> لوگو</label>
                    </div>
                    <div className="">
                      <label htmlFor="profile-pic-edit">
                        <div className="profile-pic position-relative">
                          <input
                            className="d-none"
                            type="file"
                            // accept="image/*"
                            id="profile-pic-edit"
                            // value={}
                            onChange={(e) => {
                              // if (!isNaN(e.target.value))
                              console.log("edit");

                              console.log("e", e.target.files[0]);
                              setInptValue((prev) => {
                                return { ...prev, logo: e.target.files[0] };
                              });
                            }}
                          />
                          {console.log("inputValue", inputValue)}
                          {inputValue.logo ? (
                            <img
                              src={
                                typeof inputValue.logo == "string"
                                  ? `http://marketgroup.tatdemo.ir/${inputValue.logo}`
                                  : URL.createObjectURL(inputValue.logo)
                              }
                              style={{
                                width: "80px",
                                borderRadius: "10%",
                                height: "80px",
                                overflow: "hidden",
                              }}
                              alt=""
                            />
                          ) : (
                            <FcPicture
                              style={{
                                width: "80px",
                                // borderRadius: "50%",
                                height: "80px",
                                overflow: "hidden",
                              }}
                            />
                          )}

                          <p></p>
                          <label
                            htmlFor="AddProfilePic"
                            className="position-absolute containBoxdark"
                            style={{
                              right: "8px",
                              top: "0px",
                              cursor: "pointer",
                            }}
                          >
                            <FaPlusCircle />
                          </label>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
                <div
                  className="edit-user-item mt-2 row p-2"
                  style={{ marginTop: "-35px" }}
                >
                  <div className="col-12 col-md-6">
                    <div className="lable-modal">
                      <label htmlFor="title"> عنوان</label>
                    </div>
                    <div className="">
                      <input
                        type="text"
                        id="title"
                        name="title"
                        className="input-modal"
                        value={inputValue.title}
                        onChange={(e) => {
                          // if (!isNaN(e.target.value))
                          setInptValue((prev) => {
                            return { ...prev, title: e.target.value };
                          });
                        }}
                      ></input>
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            inputValueValid.title == "" ? "visible" : "hidden",
                        }}
                      >
                        لطفا عنوان فروشگاه را وارد کنید.
                      </p>
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <div className="lable-modal">
                      <label htmlFor="covr"> کاور</label>
                    </div>
                    <div className="">
                      <input
                        type="file"
                        id="covr"
                        name="tel"
                        className="input-modal"
                        // value={inputValue.cover}
                        onChange={(e) => {
                          // if (!isNaN(e.target.value))
                          setInptValue((prev) => {
                            return { ...prev, cover: e.target.files[0] };
                          });
                        }}
                      ></input>
                      <p></p>
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <div className="lable-modal">
                      <label htmlFor="tell"> تلفن</label>
                    </div>
                    <div className="">
                      <input
                        type="text"
                        id="tell"
                        name="tel"
                        required
                        className="input-modal"
                        value={inputValue.tell}
                        onChange={(e) => {
                          console.log(
                            "inputValue",
                            inputValue.tell,
                            !isNaN(inputValue.tell)
                          );
                          if (!isNaN(e.target.value))
                            setInptValue((prev) => {
                              return { ...prev, tell: e.target.value };
                            });
                        }}
                      ></input>
                      <p
                        style={{
                          display: inputValueValid.tell ? "none" : "block",
                          color: "red",
                          fontSize: "13px",
                        }}
                      >
                        تلفن وارد شده اشتباه است .
                      </p>
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <div className="lable-modal">
                      <label htmlFor="mobi"> موبایل</label>
                    </div>
                    <div className="">
                      <input
                        type="text"
                        id="mobi"
                        name="mob"
                        className="input-modal"
                        value={inputValue.mobile}
                        // value={
                        //   inputValue.userInfo == undefined
                        //     ? ""
                        //     : inputValue.userInfo.mobile
                        // }
                        onChange={(e) => {
                          console.log(
                            "inputValueMobile",
                            inputValue.mobile,
                            !isNaN(inputValue.mobile)
                          );
                          if (!isNaN(e.target.value))
                            setInptValue((prev) => {
                              return { ...prev, mobile: e.target.value };
                            });
                        }}
                      ></input>
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            inputValueValid.mobile == "" ? "visible" : "hidden",
                        }}
                      >
                        لطفا موبایل را وارد کنید.
                      </p>
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <div className="lable-modal">
                      <label htmlFor="instagram"> اینستاگرام</label>
                    </div>
                    <div className="">
                      <input
                        type="text"
                        id="instagram"
                        name="instagram"
                        className="input-modal"
                        value={inputValue.insta}
                        onChange={(e) => {
                          // if (!isNaN(e.target.value))
                          setInptValue((prev) => {
                            return { ...prev, insta: e.target.value };
                          });
                        }}
                      ></input>
                      <p></p>
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <div className="lable-modal">
                      <label htmlFor="whatsapp"> واتساپ</label>
                    </div>
                    <div className="">
                      <input
                        type="text"
                        id="whatsapp"
                        name="whatsapp"
                        className="input-modal"
                        value={inputValue.whatsApp}
                        onChange={(e) => {
                          // if (!isNaN(e.target.value))
                          setInptValue((prev) => {
                            return { ...prev, whatsApp: e.target.value };
                          });
                        }}
                      ></input>
                      <p></p>
                    </div>
                  </div>

                  <div className="col-12 col-lg-4">
                    <div className="lable-modal">
                      <label htmlFor="city"> نوع فروشگاه</label>
                    </div>
                    <div className="">
                      <Select
                        id="city"
                        className="input-modal"
                        options={type}
                        value={type.find((val) => val.value == inputValue.type)}
                        onChange={(e) => {
                          setInptValue((prev) => {
                            return { ...prev, type: e.value };
                          });
                        }}
                      />
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            inputValueValid.type == "" ? "visible" : "hidden",
                        }}
                      >
                        لطفا نوع فروشگاه را وارد کنید.
                      </p>
                    </div>
                  </div>

                  <div className="col-12 col-lg-4">
                    <div className="lable-modal">
                      <label htmlFor="city"> شهر</label>
                    </div>
                    <div className="">
                      <Select
                        id="city"
                        className="input-modal"
                        options={city}
                        value={city.find((val) => val.value == inputValue.city)}
                        onChange={(e) => {
                          setInptValue((prev) => {
                            return { ...prev, city: e.value };
                          });
                        }}
                      />
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            inputValueValid.city == "" ? "visible" : "hidden",
                        }}
                      >
                        لطفا نام شهر را وارد کنید.
                      </p>
                    </div>
                  </div>

                  <div className="col-12 col-lg-4">
                    <div className="lable-modal">
                      <label htmlFor="city"> انتخاب کاربر</label>
                    </div>
                    <div className="">
                      <Select
                        styles={{ width: "100%", border: "none" }}
                        id="user"
                        className="input-modal"
                        options={user}
                        value={user.find((val) => val.value == inputValue.user)}
                        onChange={(value) => {
                          changeHandler(value, "user");
                          if (value.value == "create") {
                            setDisplayStatus("d-block");
                          } else {
                            setDisplayStatus("d-none");
                          }
                        }}
                      />
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            inputValueValid.user == "" ? "visible" : "hidden",
                        }}
                      >
                        لطفا نام کاربر را وارد کنید.
                      </p>
                    </div>
                  </div>

                  {/* ایجادکاربر جدید */}
                  <div
                    className={`row d-flex  ${displayStatus} `}
                    style={{
                      border: "1px dashed #6A5ACD",
                      backgroundColor: "#d4e0cc",
                      marginRight: "1px",
                    }}
                  >
                    <div className="col-12 col-lg-4">
                      <div className="label-modal">
                        <label style={{ whiteSpace: "nowrap" }}>
                          نام کاربر
                        </label>
                      </div>
                      <div className="">
                        <input
                          className="input-modal"
                          type="text"
                          value={newUser.fName}
                          onChange={(e) => {
                            setNewUser((prev) => {
                              return { ...prev, fName: e.target.value };
                            });
                          }}
                        ></input>
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility:
                              newUserValid.fName == "" ? "visible" : "hidden",
                          }}
                        >
                          لطفا عنوان فروشگاه را وارد کنید.
                        </p>
                      </div>
                    </div>
                    <div className="col-12 col-lg-4">
                      <div className="label-modal">
                        <label style={{ whiteSpace: "nowrap" }}>
                          نام خانوادگی کاربر
                        </label>
                      </div>
                      <div className="">
                        <input
                          className="input-modal"
                          type="text"
                          value={newUser.lName}
                          onChange={(e) => {
                            setNewUser((prev) => {
                              return { ...prev, lName: e.target.value };
                            });
                          }}
                        ></input>
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility:
                              newUserValid.lName == "" ? "visible" : "hidden",
                          }}
                        >
                          لطفا عنوان فروشگاه را وارد کنید.
                        </p>
                      </div>
                    </div>
                    <div className="col-12 col-lg-4">
                      <div className="label-modal">
                        <label style={{ whiteSpace: "nowrap" }}>
                          موبایل کاربر
                        </label>
                      </div>
                      <div className="">
                        <input
                          className="input-modal"
                          type="text"
                          value={newUser.mobile}
                          onChange={(e) => {
                            setNewUser((prev) => {
                              return { ...prev, mobile: e.target.value };
                            });
                          }}
                        ></input>
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility:
                              newUserValid.mobile == "" ? "visible" : "hidden",
                          }}
                        >
                          لطفا عنوان فروشگاه را وارد کنید.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <div className="lable-modal">
                      <label htmlFor="address2"> آدرس</label>
                    </div>
                    <div className="">
                      <textarea
                        type="text"
                        id="address2"
                        name="address"
                        className="input-modal"
                        value={inputValue.address}
                        onChange={(e) => {
                          // if (!isNaN(e.target.value))
                          setInptValue((prev) => {
                            return { ...prev, address: e.target.value };
                          });
                        }}
                      ></textarea>
                      <p></p>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 ">
                    <div className="lable-modal">
                      <label htmlFor="desc"> توضیحات</label>
                    </div>
                    <div className="">
                      <textarea
                        type="text"
                        id="desc"
                        name="desc"
                        className="input-modal"
                        value={inputValue.desc}
                        onChange={(e) => {
                          // if (!isNaN(e.target.value))
                          setInptValue((prev) => {
                            return { ...prev, desc: e.target.value };
                          });
                        }}
                      ></textarea>
                      <p></p>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            setForceUpdate((prev) => !prev);

            setShowEditStoreModal(false);
          }}
        >
          بستن
        </Button>
        <button
          type="button"
          closeButton
          className="btn btn-primary"
          onClick={() => {
            console.log("inpuvalue:", inputValue);
            if (inputValue.user.value == "create" && ValidationNewUser()) {
              sendEditStoreModal();
            } else if (Validation()) {
              console.log("dat", inputValue);
              sendEditStoreModal();
            }
          }}
        >
          ویرایش
        </button>
      </Modal.Footer>
    </Modal>
  );
  return createPortal(modalVar1, document.querySelector("#modals"));
}
